import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

const styles = {
  zeroMargin: {
    m: 0,
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: 'grey.800',
    fontWeight: '600',
    fontSize: '14px',
    ml: '10px',
  },
  dateBoxGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    columnGap: '10px',
  },
  selectRequestText: {
    fontSize: 14,
    fontWeight: '500',
    color: 'grey.800',
  },
  fieldContainer: {
    display: 'flex',
    gap: '23px',
    mt: '24px',
  },
  labelStyle: {
    wordWrap: 'normal',
    whiteSpace: 'normal',
    fontSize: 12,
    textAlign: 'left',
    minWidth: '80px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
